import React, { Component } from "react";
import { createStore, applyMiddleware } from "redux";
import { Provider, connect } from "react-redux";
import reducer from "../../reducers/service/index_of_not_signed_in";
import actionCreators from "../../actions/service/index_of_not_signed_in";
import TopFeaturedCircleList from "../../components/service/top_featured_circle_list";
import NewArrivalCircleList from "../../components/service/new_arrival_circle_list";
import PopularEventList from "../../components/top/popular_event_list";
import TopReportList from "../../components/top/top_report_list";
import TopBlogList from "../../components/top/top_blog_list";

const store = createStore(reducer, applyMiddleware());

export default class ServiceIndexOfNotSignedIn extends Component {
  UNSAFE_componentWillMount() {
    store.dispatch(
      actionCreators.service.indexOfNotSignedIn.set(
        this.props.isWebViewTabApp,
        this.props.circles,
        this.props.newArrivalCircles,
        this.props.events,
        this.props.blogs,
        this.props.reports,
        this.props.serviceName
      )
    );
  }

  render() {
    return (
      <Provider store={store}>
        <Root />
      </Provider>
    );
  }
}

const TmpRoot = ({ state }) => {
  var genreSearch = "";
  if (
    state.serviceName != "つなげーと" ||
    typeof state.serviceName != "undefined"
  ) {
    genreSearch = "/?keyword=" + state.serviceName;
  }
  const moreBtn = state.isWebViewTabApp ? (
    ""
  ) : (
    <article className="timeline-box">
      <a
        className="btn btn-info btn-md full-width g-mt-10 g-mb-20"
        href={`/search${genreSearch}`}
        style={{ color: "#fff" }}
      >
        <span
          className="glyphicon glyphicon-search fs14 bold"
          aria-hidden="true"
        />{" "}
        もっとサークルを検索
      </a>
    </article>
  );
  return (
    <div className="timeline-container">
      <TopFeaturedCircleList
        isWebViewTabApp={state.isWebViewTabApp}
        circles={state.circles}
        serviceName={state.serviceName}
      />
      <NewArrivalCircleList
        isWebViewTabApp={state.isWebViewTabApp}
        newArrivalCircles={state.newArrivalCircles}
      />
      {moreBtn}
      <PopularEventList events={state.events} />
      <TopBlogList blogs={state.blogs} />
      <TopReportList reports={state.reports} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  state,
});

const Root = connect(mapStateToProps)(TmpRoot);
